import styled from 'styled-components';

export const StyledContainer = styled.main`
  width: 100%;
  margin-top: 45px;

  p {
    line-height: 1.5rem;
  }

  .baseline-text {
    line-height: 1rem;
  }

  .left-col-header {
    font-size: 23px;
    margin-bottom: 18px;
  }

  .column-margin {
    margin-right: 55px;
  }

  .right-col-header {
    font-size: 28px;
  }
`;
